import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import { setBookParams } from "./catalogSlice";
import SearchIcon from '@mui/icons-material/Search';

interface Props {
  disabled: boolean;
}

const BookSearch: React.FC<Props> = ({ disabled }) => {
  const { bookParams } = useAppSelector(state => state.catalog);
  const dispatch = useAppDispatch();

  // Local state for search term
  const [searchTerm, setSearchTerm] = useState(bookParams.searchTerm);

  const searchBooks = () => {
    dispatch(setBookParams({ searchTerm }));
  }

  return (
   <TextField
  label="Search book title"
  variant="outlined"
  fullWidth
  value={searchTerm || ""}
  disabled={disabled}
  onChange={(event) => setSearchTerm(event.target.value)}
  onKeyDown={(event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      searchBooks();
    }
  }}
  slotProps={{
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            disabled={disabled}
            onClick={searchBooks}
            component="a" {...{ name: "search-icon" }} id="search-icon-btn"
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      ),
    },
  }}
  className="searchInput"
/>

  )
}

export default BookSearch;
